/**
 * Parses a YYYY-MM-DD string as a local calendar date (no timezone shift).
 * Use this instead of new Date(str) which treats the string as UTC midnight.
 *
 * @param {string|null|undefined} str — "YYYY-MM-DD"
 * @returns {Date|null}
 */
export function parseLocalDate(str) {
  if (!str) return null;
  const [year, month, day] = str.split('-').map(Number);
  return new Date(year, month - 1, day);
}
